export default {
      id: "i-bank-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-bank",
      toString: function () {
        return this.url;
      }
    }